// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.user-name,\n.el-table td.user-name {\n  width: 12em;\n}", ""]);
// Exports
module.exports = exports;
